import { createAction } from 'redux-actions';
export const setAccountNumber = createAction('FLEX_FINALIZE/SET_ACCOUNT_NUMBER');
export const setAutopayCompleted = createAction('FLEX_FINALIZE/SET_AUTOPAY_COMPLETED');
export const setBankAccounts = createAction('FLEX_FINALIZE/SET_BANK_ACCOUNTS');
export const setSelectedBankAccount = createAction('FLEX_FINALIZE/SET_SELECTED_BANK_ACCOUNT');
export const setAuthorizationToken = createAction('FLEX_FINALIZE/SET_AUTHORIZATION_TOKEN');
export const setInstrumentId = createAction('FLEX_FINALIZE/SET_INSTRUMENT_ID');
export const setSigningUrl = createAction('FLEX_FINALIZE/SET_SIGNING_URL');
export const setFinancialStatus = createAction('FLEX_FINALIZE/SET_FINANCIAL_STATUS');
export const clearFlexFinalizeData = createAction('FLEX_FINALIZE/CLEAR_FLEX_FINALIZE_DATA');
export const setPaymentOption = createAction('FLEX_FINALIZE/SET_PAYMENT_OPTION');
